<template>
    <div class="group-page-menu-sharing">
        <div>
            <div class="text-center">
                <span class="group-page-menu-sharing__header">
                    {{ group.name }}<br>
                    Sharing Dashboard
                </span>
            </div>
        </div>
        <div style="text-align: center">
            <group-page-menu-sharing-panel-item
                    v-for="item in items"
                    :item="item"
                    :key="item.iconClass"
            ></group-page-menu-sharing-panel-item>
        </div>
    </div>
</template>

<script>
    import GroupPageMenuSharingPanelItem from "./GroupPageMenuSharingPanelItem";

    export default {
        name: "GroupPageMenuSharingPanel",
        components: {GroupPageMenuSharingPanelItem},
        props: {
            group: Object,
            sharingState: Object,
        },
        computed: {
            header() {
                return ``;
            },
            items() {
                return [
                    {
                        label: 'Stories',
                        iconClass: 'stories',
                        count: this.sharingState.stories.count,
                        hasNew: this.sharingState.stories.has_new,
                        to: 'groupDetailPage-shared-stories',
                        active: this.$route.name === 'groupDetailPage-shared-stories',
                    },
                    {
                        label: 'Media',
                        iconClass: 'media',
                        count: this.sharingState.media.count,
                        hasNew: this.sharingState.media.has_new,
                        to: 'groupDetailPage-shared-media',
                        active: this.$route.name === 'groupDetailPage-shared-media',
                    },
                    {
                        label: 'Wikis',
                        iconClass: 'wiki',
                        count: this.sharingState.wiki.count,
                        hasNew: this.sharingState.wiki.has_new,
                        to: 'groupDetailPage-shared-wiki',
                        active: this.$route.name === 'groupDetailPage-shared-wiki',
                    },
                ];
            },
        }
    };
</script>

<style scoped lang="scss">
  @import "../../styles/const";
  @import "../../styles/mixins";

  .group-page-menu-sharing {
    margin-top: 10px;
    text-align: left;
    padding: 0 15px;

    background-color: $menu-blue;
    border-radius: 5px;

    &__header {
      color: white;
      font-size: 22px;
      font-weight: bold;
    }
  }
</style>